import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.DELETE_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/deleteCategory.js